/* Allows the td area to be selected triggering the radio button */
$(document).ready(function() {
  radioButtonSelect();
  updateTable();
});


var updateTable = function() {
  var tableItems  = $("table.choice_table td");
  choiceInputToTD(tableItems);
};

function choiceInputToTD($this) {
  $this.on('click', tdClickHandler);
}

var tdClickHandler = function() {
  radioSelect($(this));
}

function radioSelect($this) {
  if ($this.children("input").is(':radio')) {
    selectButton($this);
    radioButtonSelect();
  } else {
    return false;
  }
}

function selectButton($this) {
  $this.find("input").prop("checked", true).trigger('change');
}

function radioButtonSelect() {
  $(".choice_table input[type='radio']").each(function() {
    if ( $(this).is(":checked") ) {
      $(this).parent().addClass('selected');
    } else {
      $(this).parent().removeClass('selected');
    }
  });
}
